import React, { Component } from "react";

import { withRequest } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";

class Sucursales extends Component {
    state = {
        sucursales: {},
        sucursal: {},
        links: null,
        showCreate: false,
        showEdit: false,
        loading: true,
    };
    componentDidMount() {
        this.getSucursales();
    }
    getSucursales = async (url = null) => {
        url = url ? url : "sucursales";
        const sucursales = await this.props.request(url);

        if (sucursales.data) {
            this.setState({
                sucursales: sucursales.data,
                loading: false,
            });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate,
            sucursal: { operadores: [] },
        });
    };
    toggleEditModal = (sucursal) => {
        this.setState({
            showEdit: !this.state.showEdit,
            sucursal: sucursal,
        });
    };
    render() {
        const { sucursales, loading } = this.state;
        return (
            <div>
                <div className='page-header'>
                    <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                    <h1 className='page-title row'>
                        <span className='col'>Sucursales</span>
                        <button
                            className='au-btn au-btn-icon au-btn--green au-btn--small'
                            onClick={this.toggleCreateModal}>
                            <i className='zmdi zmdi-plus' />
                            Añadir Sucursal
                        </button>
                    </h1>
                </div>
                <div className='row'>
                    <div className='col-md-12'>
                        <div>
                            {loading && <Loader />}
                            {!sucursales.length ? (
                                <div>
                                    {!loading && (
                                        <div>
                                            Todavía no hay categorías creadas.
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className='table-data'>
                                    <table className='table table-data2'>
                                        <thead>
                                            <tr>
                                                <th>Nombre</th>
                                                <th>Dirección</th>
                                                <th>Sistema</th>
                                                <th />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sucursales.map((sucursal) => (
                                                <tr
                                                    className='tr-shadow'
                                                    key={sucursal.id}>
                                                    <td>{sucursal.nombre}</td>
                                                    <td>
                                                        {sucursal.direccion}
                                                    </td>
                                                    <td>{sucursal.sistema}</td>
                                                    <td>
                                                        <div className='table-data-feature'>
                                                            <button
                                                                className='item'
                                                                data-toggle='tooltip'
                                                                data-placement='top'
                                                                title=''
                                                                data-original-title='Edit'
                                                                onClick={() => {
                                                                    this.toggleEditModal(
                                                                        sucursal
                                                                    );
                                                                }}>
                                                                <i className='zmdi zmdi-edit' />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {this.state.links && (
                                        <Pagination
                                            links={this.state.links}
                                            meta={this.state.meta}
                                            getData={this.getSucursales}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <Create
                        toggle={this.toggleCreateModal}
                        sucursal={this.state.sucursal}
                        sucursales={sucursales}
                        getSucursales={this.getSucursales}
                    />
                </Modal>
                <Modal
                    show={this.state.showEdit}
                    blank={true}
                    toggle={() => this.toggleEditModal({})}>
                    <Edit
                        toggle={() => this.toggleEditModal({})}
                        sucursal={this.state.sucursal}
                        sucursales={sucursales}
                        getSucursales={this.getSucursales}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Sucursales);
